module.exports = __webpack_public_path__ + "static/img/tip3.e428535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tip3.png
// module id = iUWj
// module chunks = 1